import { type FC } from 'react';

import { useTrackHoveredPinChanged } from './internal/hooks/useTrackHoveredPinChanged';

export const MapHoverPinUpdater: FC = () => {
  useTrackHoveredPinChanged();

  return null;
};
